"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      style={
        {
          "--normal-bg": "#0f172a",
          "--normal-text": "#f1f5f9",
          "--normal-border": "rgba(34, 211, 238, 0.3)",
          "--success-bg": "#0f172a",
          "--success-text": "#22d3ee",
          "--success-border": "rgba(34, 211, 238, 0.5)",
          "--error-bg": "#0f172a",
          "--error-text": "#ef4444",
          "--error-border": "rgba(239, 68, 68, 0.5)",
        } as React.CSSProperties
      }
      position="top-center"
      richColors
      closeButton
      {...props}
    />
  );
};

export { Toaster };
